export default {
    signUp: 'Cadastre-se',
    alreadyMember: 'Já é membro do Astrolink?',
    shortLogin: 'Entrar',
    createBirthChart: 'Criar Mapa Astral Grátis',

    menu: {
        // top-level / shared labels
        astrology: 'Astrologia',
        signs: 'Signos',
        ascending: 'Ascendente',
        horoscope: 'Horóscopo',
        famous: 'Mapas dos Famosos',
        astrologicalLessons: 'Lições Astrológicas',

        // mobile profile area items
        home: 'Início',
        chakrasGuide: 'Guia de Chakras',
        careerMap: 'Mapa Astral de Carreira',
        guide2026: 'Guia Astrológico 2026',
        loveMap: 'Mapa do Amor',
        orbia: 'Assistente Astrológico',
        personalHoroscope: 'Horóscopo',
        birthChart: 'Mapa Astral',
        extraMaps: 'Mapas Extra',
        compatibilities: 'Minhas Sinastrias',
        biorhythm: 'Biorritmo',
        lunarNodes: 'Nodos Lunares',
        lunarCycle: 'Ciclo Lunar',
        astrologicalGuides: 'Guias Astrológicos',
        journal: 'Diário Pessoal',
        visitors: 'Visitantes recentes',
        likes: 'Quem me curtiu',
        friends: 'Amigos',
        participants: 'Encontrar Pessoas',

        // app banner labels
        app: 'Aplicativo Astrolink',
        appButton: 'BAIXAR',
        back: 'Voltar',
        open: 'Abrir menu',

        introduction: {
            label: 'Introdução',
            history: 'A História da Astrologia',
            elements: 'Elementos, Qualidades e Polaridades',
            dignities: 'As Dignidades Planetárias',
            aspects: 'Os Aspectos Planetários',
            rulers: 'Os Regentes do Ciclo e do Ano',
            ages: 'As Eras Astrológicas',
            works: 'A Astrologia realmente funciona?'
        },

        starsAndPositions: {
            label: 'Astros e Posicionamentos',
            sunInSigns: 'Sol nos signos',
            moonInSigns: 'Lua nos signos',
            mercuryInSigns: 'Mercúrio nos signos',
            venusInSigns: 'Vênus nos signos',
            marsInSigns: 'Marte nos signos',
            jupiterInSigns: 'Júpiter nos signos',
            saturnInSigns: 'Saturno nos signos',
            uranusInSigns: 'Urano nos signos',
            neptuneInSigns: 'Netuno nos signos',
            plutoInSigns: 'Plutão nos signos',
            chironInSigns: 'Quíron nos signos',
            ascendantArticle: 'Ascendente',
            midheavenArticle: 'Meio do Céu'
        },

        houses: {
            label: 'Casas Astrológicas',
            introductionToHouses: 'Introdução às casas',
            house1: 'Casa 1',
            house2: 'Casa 2',
            house3: 'Casa 3',
            house4: 'Casa 4',
            house5: 'Casa 5',
            house6: 'Casa 6',
            house7: 'Casa 7',
            house8: 'Casa 8',
            house9: 'Casa 9',
            house10: 'Casa 10',
            house11: 'Casa 11',
            house12: 'Casa 12'
        },

        tarot: {
            label: 'Tarot',
            consultTarot: 'Consultar o Tarot',
            whatIsTarot: 'O que é o Tarot?',
            majorArcana: 'Os 22 Arcanos Maiores',
            minorArcana: 'Os 56 Arcanos Menores',
            clubsCards: 'Cartas de Paus',
            diamondsCards: 'Cartas de Ouros',
            spadesCards: 'Cartas de Espadas',
            heartsCards: 'Cartas de Copas'
        },

        blog: {
            label: 'Blog',
            basicAstrology: 'Astrologia',
            astrologyDailyLife: 'Trânsitos e previsões',
            numerology: 'Numerologia',
            tarotGypsy: 'Tarot e Baralho Cigano',
            relationship: 'Relacionamento'
        }
    }
};
